export const capitalize = (string: string): string => {
    return string.charAt(0).toUpperCase() + string.slice(1);
};

export const convertToASCII = (string: string): string => {
    const combine = /[\u0300-\u036F]/g;
    return string.normalize('NFKD').replace(combine, '');
};
